import App from '../application.js'

import './setup_i18n'
import 'jquery-validation/dist/localization/messages_pt_PT.js'
import '../vendor/bootstrap-datepicker/locales/bootstrap-datepicker.pt.js'
import 'moment/locale/pt.js'
import './translations.tc.pt.js'

$.fn.datepicker.defaults.language = 'pt'

I18n.defaultLocale = 'pt'
I18n.locale = 'pt'

export default App
